module.exports = __webpack_public_path__ + "static/img/nav-bar-bg-kiko.9a989425.webp";